

























































import vSelect from "vue-select";

export default {
  name: "BaseSelectFooter",
  components: { vSelect },
  props: {
    value: {
      type: Object,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      selected: null,
      footer: "Upload new font",
    };
  },
  methods: {
    selectedOption(option) {
      if (this.value) {
        return option.name === this.value.name;
      }
      return false;
    },
    change(e) {
      const option = this.options.find((o) => {
        return e.id === o.id;
      });
      if (option) {
        this.$emit("input", option);
      }
    },
    deleteFont(e, option) {
      e.preventDefault();
      e.stopPropagation();
      //this.options.splice(this.options.indexOf(option), 1);
      /* if (this.value === option) {
        this.$emit("input", this.options[0]);
      } */
      this.$emit("deleteFont", option);
    },
    clickFooter() {
      this.$emit("clickFooter");
    },
  },
};
